<app-header-nav [hideProgress]="hideProgress">
  <div class="row h-100 overflow-hidden">
    <div class="d-none d-md-flex col-4 position-relative h-100 side-graphic">
      <app-morphing-svg></app-morphing-svg>
      <img
        src="./assets/bg_graphics/side_bg_graphic.svg"
        alt="background rectangle"
        class="bg-img" />
    </div>
    <div class="col col-md-8 bg-white h-100 overflow-auto position-relative">
      <div class="p-3 p-md-4 h-100 route-transition">
        <router-outlet #outlet="outlet" />
      </div>
    </div>
    <app-help-btn></app-help-btn>
  </div>
</app-header-nav>
